import styled from 'styled-components';
import { AAccentLineSize, AAccentLineAlignment } from './AAccentLine.types';

const desiredWidth = '9.09%';
const minWidth = '56px';
const spacers = {
  spacers: {
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '1rem',
    4: '1.5rem',
    5: '2rem',
  },
};

export const Wrapper = styled.div<{
  alignment: AAccentLineAlignment;
  size: AAccentLineSize | string;
}>`
  width: 100%;
  display: flex;
  justify-content: ${({ alignment }) => (alignment === AAccentLineAlignment.Centered ? 'center' : 'start')};
  padding-block-start: ${spacers?.spacers?.[2] ?? '0.5rem'};
  padding-block-end: ${spacers?.spacers?.[3] ?? '1rem'};
  span {
    width: max(${minWidth}, ${desiredWidth});
    height: ${({ size }) =>
      Object.values(AAccentLineSize).includes(size as AAccentLineSize) ? size : AAccentLineSize.OnePx};
  }
`;
